import script from "./RangeSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./RangeSlider.vue?vue&type=script&setup=true&lang=ts"

import "./RangeSlider.vue?vue&type=style&index=0&id=3fa06935&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa06935"]])

export default __exports__